import { configureStore } from '@reduxjs/toolkit';
import { reducer as courseHomeReducer } from './course-home/data';
import { reducer as coursewareReducer } from './courseware/data/slice';
import { reducer as recommendationsReducer } from './courseware/course/course-exit/data/slice';
import { reducer as toursReducer } from './product-tours/data';
import { reducer as modelsReducer } from './generic/model-store';
import { reducer as appReducer } from './data';
import { reducer as specialExamsReducer } from '@edx/frontend-lib-special-exams';

export default function initializeStore() {
  console.log("Initializing Redux Store");
  return configureStore({
    reducer: {
      models: modelsReducer,
      courseware: coursewareReducer,
      courseHome: courseHomeReducer,
      recommendations: recommendationsReducer,
      tours: toursReducer,
      app: appReducer,
      specialExams: specialExamsReducer,
    },
  });
}
